module.exports = __webpack_public_path__ + "static/ju_derancourt-e363dfaf86f0fc58d23897d804d5f6ca.png";